import { stringRequired } from '@nexans/react-form/zod'
import * as z from 'zod'

import { Civility, CompanySize, Language } from '@/types/openapi'

export const PatchCurrentUserSchema = z.object({
  companyName: stringRequired()
    .max(100, 'errors.auth.company_name_max_length')
    .regex(/^[\p{L}\p{N}][\p{L}\p{N} .,'&%()\-_/+@:]*$/u, 'errors.auth.company_name_pattern'),
  companySize: z.enum(CompanySize, { error: 'form.required' }),
  companyAddress: stringRequired(),
  phoneNumber: stringRequired(),
  civility: z.enum(Civility, { error: 'form.required' }),
  lastName: stringRequired().max(50, 'errors.auth.last_name_max_length'),
  firstName: stringRequired().max(50, 'errors.auth.first_name_max_length'),
  preferredLanguage: z.enum(Language, { error: 'form.required' }),
  hasConsentedMarketing: z.boolean(),
})

export type PatchCurrentUserForm = z.infer<typeof PatchCurrentUserSchema>
